/**
 * Persisted theme variant ids (shared). Application layer may depend on this;
 * presentation maps ids → palettes via `themes` in `@/theme/tokens`.
 */
export const THEME_VARIANT = {
  /** Classic Amber (default storefront brand). Legacy persisted id was `amber`. */
  AMBER: "classic-amber",
  BLUE: "blue",
} as const;

export type ThemeVariant = (typeof THEME_VARIANT)[keyof typeof THEME_VARIANT];

/** Same values as MUI `PaletteMode`; defined here so application code avoids importing `@mui/material`. */
export type AppPaletteMode = "light" | "dark";
